import axios from 'axios'

export default {
  async get(endpoint) {
    return (await axios.get(endpoint)).data
  },

  async fetchFilters() {
    return (await axios.get(`/v1/filters`)).data
  },

  async fetchRoomTypes() {
    return (await axios.get(`/v1/room-types`)).data
  },

  async fetchFurnitureModels() {
    return (await axios.get(`/v1/furniture-models`)).data
  },

  async fetchGlobalDateRange() {
    return (await axios.get(`/v1/date-range`)).data
  },

  async fetchTotalDocumentsCount() {
    return (await axios.get(`/v1/total-count`)).data
  },

  async performSearch(params) {
    return (await axios.post(`/v1/search`, params)).data
  },

  async fetchImageSearchStats() {
    return (await axios.get(`/api/image-search/stats`)).data
  },

  async performReferenceSearch(referenceId, limit) {
    return axios.post(`/v1/search?referenceId=${referenceId}`, {
      filters: [],
      limit: limit
    })
  },

  async performImageSearch(formData) {
    return (
      await axios.post(`/api/image-search`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    ).data
  },

  async convertPlanStyle(planData, style = "WhiteBox", configName = "custom", customConfig = null) {
    const payload = {
      plan_data: planData,
      style: style,
      config_name: configName
    }

    if (customConfig) {
      payload.custom_config = customConfig
    }

    return (await axios.post(`/v1/convert-plan-style`, payload)).data
  },

  async processImage(formData) {
    return (
      await axios.post(`https://suggester.hart-digital.com/process_image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    ).data
  },

  async processImageFurniture(formData) {
    return (
      await axios.post(
        `https://suggester.hart-digital.com/process_image_furniture`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
    ).data
  },

  async getStyleConfigs() {
    return (await axios.get(`/v1/style-configs`)).data
  },

  async getStyleConfig(configId) {
    return (await axios.get(`/v1/style-configs/${configId}`)).data
  }
}
